export function formatStringDates(strDate: string): string {
  const [day, month, year] = strDate.split("/");

  return `${year}-${month}-${day}`;
}
